module.exports = __webpack_public_path__ + "media/src/ui/icons/icon_gif-076fd7d39a4a994a1e6ced4c2a3a5f96.png";